<template>
    <nav class="navbar navbar-expand-lg bg-body-tertiary">
        <div class="container-fluid" data-v="1743790037">
            <a class="navbar-brand" href="/" data-v="1756570056">
                <img id="top-menu-logo"
                    :src="logoSrc"
                    style="margin-top: -4px; width: 30px"
                    width="30"
                    height="30"
                    alt="logo"
                />
                Practice German online
            </a>

            <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <!-- <li class="nav-item">
            <router-link class="nav-link" :to="'/' + hh.l() + '/about'">About</router-link>
                    </li>-->
                    <!-- <li class="nav-item">
            <router-link class="nav-link" :to="'/' + hh.l() + '/contact'">
            {{ hh.t('contact') }}</router-link>
                    </li>-->
                    <li class="nav-item" data-v="1757844951">
                        <router-link
                            class="nav-link"
                            :to="'/german-vocabulary'"
                        >Vocabulary</router-link>
                    </li>
                    <li class="nav-item" data-v="1757844953">
                        <router-link
                            class="nav-link"
                            :to="'/german-pronunciation'"
                        >German Pronunciation</router-link>
                    </li>
                </ul>
                <ul class="navbar-nav mb-2 mb-lg-0" data-v="1743849886">
                    <!-- <li class="nav-item">
            <router-link class="nav-link" to="/register" data-v="1744019855">{{ hh.t('register') }}</router-link>
                    </li>-->
                    <li v-if="!isLoggedIn" class="nav-item" data-v="1756739808">
                        <router-link class="nav-link" to="/login">Login</router-link>
                    </li>
                    <li v-if="isLoggedIn" class="nav-item dropdown" data-v="1756739816">
                        <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            {{ user.name }}
                        </a>
                        <ul class="dropdown-menu">
                            <li><router-link class="dropdown-item" to="/user-profile">Profile</router-link></li>
                            <li><a class="dropdown-item" href="#">Settings</a></li>
                            <li><hr class="dropdown-divider"></li>
                            <li><router-link class="dropdown-item" to="/logout">Logout</router-link></li>
                        </ul>
                    </li>

                    <li class="nav-item" data-v="1756739818">
                        <router-link
                            v-if="isAdmin"
                            class="nav-link"
                            to="/admin"
                            data-v="1743942698"
                        >Admin: {{ user.name }}</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
    <main id="simple-app">
        <div id="flash-alert" class="flash-alert" style="display: none;" data-v="1755503924"></div>
        <router-view />
    </main>
    <footer-view></footer-view>
</template>

<script>

import { provide, reactive } from 'vue' // Import provide from Vue
import H from "./services/helpers.js"
import { storeToRefs } from 'pinia'
import { useUserStore } from './stores/userStore'
import footerView from './views/part/Footer.vue'

export default {
    components: { footerView },
    setup() {
        const hh = new H()
        provide('hh', hh) // Provide the helper class globally
        const userStore = useUserStore()
        const { user, isLoggedIn, isAdmin } = storeToRefs(userStore)
        const U = reactive({ user: user, isAdmin: isAdmin, isLoggedIn: isLoggedIn })
        provide('U', U)
        return { hh, user, isLoggedIn, isAdmin }
    },
    computed: {
        logoSrc() {
            const hostname = window.location.hostname
            if (hostname.includes('localhost')) {
                return '/images/logo/local_logo.png'
            } else {
                return '/images/logo/logo_30.avif'
            }
        }
    },
    mounted() {
        this.setFavicon()
    },
    methods: {
        setFavicon() {
            const favicon = document.querySelector('link[rel="icon"]') || document.createElement('link')
            favicon.rel = 'icon'
            // Set different favicons based on environment
            // get the domain name 
            const domain = window.location.hostname
            //    alert(domain)
            if (domain.includes('localhost')) {
                favicon.href = '/local_favicon.ico'
            } else if (domain.includes('stage')) {
                favicon.href = '/stage_favicon.ico'
            } else {
                favicon.href = '/favicon.ico' // production
            }

            document.head.appendChild(favicon)
        }
    }
}
</script>

<style lang="scss">
/* Active navigation link styling */
.navbar-nav .nav-link.router-link-active {
    text-decoration: underline;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
}

/* Optional: Add hover effect for all nav links */
.navbar-nav .nav-link {
    transition: text-decoration 1.2s ease;
}

.navbar-nav .nav-link:hover {
    text-decoration: underline;
    text-underline-offset: 4px;
    text-decoration-thickness: 1px;
}
</style>
